/**
 * Reactive call state — reads from the Agora SDK (via useAgoraCall)
 * instead of Convex, so Agora is the single source of truth.
 */

import { useMemo } from 'react'
import type { AgoraCallState } from './types'

export type CallParticipant = {
  uid: number
  hasAudio: boolean
  hasVideo: boolean
}

export function useCallState(agoraState: AgoraCallState) {
  return useMemo(() => {
    const { isConnected, isPublishing, localMicEnabled, localCameraEnabled, remoteUsers } = agoraState

    return {
      isInCall: isConnected,
      /** User has actively enabled mic or camera (not just passively listening). */
      isPublishing,
      isMuted: !localMicEnabled,
      isCameraOn: localCameraEnabled,
      remoteUsers,
      participantsByUid: Object.fromEntries(remoteUsers.map((u) => [u.uid, u]))
    }
  }, [agoraState])
}
